import { render } from "./FormEgreso.vue?vue&type=template&id=59c25dc6"
import script from "./FormEgreso.vue?vue&type=script&lang=js"
export * from "./FormEgreso.vue?vue&type=script&lang=js"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__